const advantagePaymentTypeCodes = {
    visa: "VS",
    americanExpress: "AX",
    discover: "DC",
    masterCard: "MC"
};

export default advantagePaymentTypeCodes;
